import gql from 'graphql-tag';

export const GET_DISCIPLINES = gql`
  query GetDisciplines {
    getDisciplines {
      _id
      name
    }
  }
`;

export const GET_DISCIPLINES_PAGINATED = gql`
  query GetDisciplinesPaginated($query: DisciplineQueryInput!) {
    getDisciplinesWithPagination(query: $query) {
      total
      currentPage
      data {
        _id
        name
        description
        type
        types
        countries
      }
    }
  }
`;
